<template>
  <div class="w-full">
    <vs-select class="w-full" autocomplete v-model="selectOption" :disabled="readonly">
      <vs-select-item v-for="option in getOptions" :text="option.text" :value="option.value"/>
    </vs-select>
  </div>
</template>

<script>
import 유해위험요인 from "./유해위험요인.js";
export default {
  name: "RiskFactSelector",
  props: {
    value: String | Array,
    readonly: Boolean,
    분류: String,
  },
  computed: {
    selectOption: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },

    getOptions () {
      const options = [];
      if (!this.분류) {
        for (const option of this.유해위험요인) {
          options.push({ text: option.text, value: option.value });
        }
      } else {
        for (const option of this.유해위험요인) {
          if (option.value === this.분류) {
            for (const child of option.children) {
              options.push({ text: child.text, value: child.value });
            }
          }
        }
      }
      return options
    },
  },
  watch: {
    getOptions:{
      immediate: true,
      deep: true,
      handler () {
        if (this.getOptions.length > 0) {
          if (!this.value) {
            this.selectOption = this.getOptions[0].value;
          }
        }
      }
    },
  },
  data() {
    return {
      유해위험요인,
    }
  },
}
</script>

<style scoped>

</style>
